import { Country } from '../../../dtos/countries.dto';

export function countryName(countryCode: string, countriesData: Country[]): string {
  const country = countriesData.find((country) => country.code === countryCode);
  return country ? country.name : 'Unknown Country';
}
